<template>
  <LKLayout class="BLayoutDetach" hidden>
    <transition name="fade-slow" mode="out-in">
      <router-view v-if="ready" />

      <LKProgressCircular
        v-else
        overlay
        :size="50"
        style="align-items: start; padding-top: 30vh;"
      />
    </transition>
  </LKLayout>
</template>

<script>
import LKLayout from './components/BLayoutLK/LKLayout.vue'

export default {
  name: 'BLayoutDetach',
  components: {
    LKLayout,
  },
  props: {
    ready: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss" src="@/assets/scss/transitions/transition-fade.scss"></style>

<style lang="scss">
.BLayoutDetach {
  @import "~@/assets/scss/webflow/fisoko.webflow";

  font-family: $webflow-font-family;
  font-size: 14px;
  line-height: 20px;
  color: $webflow-color-black;
}
</style>
